module.exports = __webpack_public_path__ + "static/media/README.edb3aef5.md";